// extracted by mini-css-extract-plugin
export default {"wrapper":"UserTextIcon_wrapper__uol0e","small":"UserTextIcon_small__f7gd4"};